/**
 * Centralized chart color palette.
 * Values match existing chart hex usage — centralize only, do not rebrand.
 */

export const chartPalette = {
  // Semantic series / status
  indigo: "#6366f1",
  success: "#22c55e",
  successStrong: "#16a34a",
  warning: "#f59e0b",
  warningYellow: "#eab308",
  danger: "#ef4444",
  orange: "#f97316",
  purple: "#8b5cf6",
  teal: "#14b8a6",
  pink: "#ec4899",
  slate: "#64748b",
  cyan: "#06b6d4",
  blue: "#3b82f6",
  blueLight: "#60a5fa",
  blueLighter: "#93c5fd",
  blueLightest: "#bfdbfe",
  sky: "#0ea5e9",
  emerald: "#10b981",
  muted: "#9ca3af",

  // Chart chrome (grid, axes, tracks)
  grid: "#e5e7eb",
  gridSoft: "#f0f0f0",
  axis: "#9ca3af",
  track: "#e5e7eb",
  trackMuted: "#f3f4f6",
  targetSoft: "#dbeafe",
  targetMuted: "#e2e8f0",
};

/** Multi-series categorical palette — order must stay stable. */
export const chartSeries = [
  chartPalette.indigo,
  chartPalette.success,
  chartPalette.warning,
  chartPalette.danger,
  chartPalette.purple,
  chartPalette.teal,
  chartPalette.orange,
  chartPalette.pink,
  chartPalette.slate,
  chartPalette.cyan,
];

/** Alias for existing CHART_COLORS consumers. */
export const CHART_COLORS = chartSeries;

/** Customer funnel blue ramp — order must stay stable. */
export const funnelSeries = [
  chartPalette.sky,
  chartPalette.blue,
  chartPalette.blueLight,
  chartPalette.blueLighter,
  chartPalette.blueLightest,
];

/** Brand contribution series colors. */
export const brandSeries = {
  henkel: chartPalette.sky,
  golrang: chartPalette.warning,
  others: chartPalette.purple,
};

/**
 * Standard achievement scale (TargetGauge, SellerRankingChart).
 * Thresholds: 100 / 90 / 75 / 50.
 */
export function achievementColor(value) {
  const v = Number(value);
  if (v >= 100) return chartPalette.successStrong;
  if (v >= 90) return chartPalette.success;
  if (v >= 75) return chartPalette.warningYellow;
  if (v >= 50) return chartPalette.orange;
  return chartPalette.danger;
}

/**
 * DC comparison achievement scale.
 * Thresholds: 100 / 90 / 80 / 70.
 */
export function achievementColorDc(value) {
  const v = Number(value);
  if (v >= 100) return chartPalette.successStrong;
  if (v >= 90) return chartPalette.success;
  if (v >= 80) return chartPalette.warningYellow;
  if (v >= 70) return chartPalette.orange;
  return chartPalette.danger;
}

/**
 * Compact gauge achievement scale (DetailedGauge / MiniGauge).
 * Thresholds: 100 / 90 / 75.
 */
export function achievementColorGauge(value) {
  const v = Number(value);
  if (v >= 100) return chartPalette.success;
  if (v >= 90) return chartPalette.warningYellow;
  if (v >= 75) return chartPalette.orange;
  return chartPalette.danger;
}

/**
 * Sale % bar color for breakdown charts.
 * null → muted; thresholds: 100 / 80 / 60.
 */
export function salePctColor(pct) {
  if (pct == null) return chartPalette.muted;
  if (pct >= 100) return chartPalette.success;
  if (pct >= 80) return chartPalette.indigo;
  if (pct >= 60) return chartPalette.warning;
  return chartPalette.danger;
}
